import styled from 'styled-components';

export const RightWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;
